// src/pages/AccountPage.jsx
import { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Text,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Avatar,
  HStack,
} from "@chakra-ui/react";
import { supabase } from "../utils/supabaseClient";
import useBusinessGuard from "../hooks/useBusinessGuard";

export default function AccountPage() {
  const { authId, loading } = useBusinessGuard();
  const [business, setBusiness] = useState(null);
  const [loadingBusiness, setLoadingBusiness] = useState(true);

  useEffect(() => {
    if (!authId) return;

    const loadBusiness = async () => {
      setLoadingBusiness(true);

      const { data, error } = await supabase
        .from("businesses")
        .select("name, email, postcode, tagline, logo_url, brand_color")
        .eq("auth_id", authId)
        .single();

      if (error || !data) {
        console.error("[AccountPage] load error:", error);
        setBusiness(null);
      } else {
        setBusiness(data);
      }

      setLoadingBusiness(false);
    };

    loadBusiness();
  }, [authId]);

  if (loading) {
    return (
      <Box p={8}>
        <Text>Loading account…</Text>
      </Box>
    );
  }

  return (
    <Box p={8}>
      <Heading mb={4}>Account</Heading>
      <Text mb={6} color="gray.600">
        Your business profile details.
      </Text>

      {loadingBusiness ? (
        <Text>Loading business profile…</Text>
      ) : !business ? (
        <Text>Business profile not found.</Text>
      ) : (
        <Stack spacing={6} maxW="480px">
          <HStack spacing={4}>
            <Avatar
              name={business.name}
              src={business.logo_url || undefined}
              bg={business.brand_color || "red.500"}
            />
            <Box>
              <Text fontWeight="bold">{business.name}</Text>
              <Text fontSize="sm" color="gray.500">
                {business.tagline || "Your tagline will appear here."}
              </Text>
            </Box>
          </HStack>

          <FormControl>
            <FormLabel>Business name</FormLabel>
            <Input value={business.name} isReadOnly />
          </FormControl>

          <FormControl>
            <FormLabel>Email</FormLabel>
            <Input value={business.email} isReadOnly />
          </FormControl>

          <FormControl>
            <FormLabel>Postcode</FormLabel>
            <Input value={business.postcode} isReadOnly />
          </FormControl>

          <FormControl>
            <FormLabel>Tagline</FormLabel>
            <Input value={business.tagline || ""} isReadOnly />
          </FormControl>
        </Stack>
      )}
    </Box>
  );
}
